import actionTypes from '../../../redux/actions/action-types';

export const getChartsAction = (data) => ({
  type: actionTypes.chartsPage.getCharts,
  data,
});

export const pageUpdateAction = (data) => ({
  type: actionTypes.chartsPage.pageUpdate,
  data,
});

export const getTagsAction = (data) => ({
  type: actionTypes.chartsPage.getTags,
  data,
});

export const setSelectFilterAction = (data) => ({
  type: actionTypes.chartsPage.setSelectFilter,
  data,
});

export const getCreatorsAction = (data) => ({
  type: actionTypes.chartsPage.getCreators,
  data,
});

export const setAction = (data) => ({
  type: actionTypes.chartsPage.set,
  data,
});

export const deleteChartAction = (data) => ({
  type: actionTypes.chartsPage.deleteChart,
  data,
});

export const recoverChartAction = (data) => ({
  type: actionTypes.chartsPage.recoverChart,
  data,
});

export const convertToThemeAction = (data) => ({
  type: actionTypes.chartsPage.convertToTheme,
  data,
});

export const duplicateToThemeAction = (data) => ({
  type: actionTypes.chartsPage.duplicateToTheme,
  data,
});

export const duplicateChartAction = (data) => ({
  type: actionTypes.chartsPage.duplicateChart,
  data,
});

export const SetChartMetaAction = (data) => ({
  type: actionTypes.chartsPage.setChartMeta,
  data,
});
